module.exports = __webpack_public_path__ + "assets/img/block-right-hover-a39fe47e.png";